import { createFileRoute, redirect } from "@tanstack/react-router"

// Google crawled a stale `/guide` canonical that now 404s — the guide library
// lives at /trips/explore. This bare `/guide` route only matches the exact path;
// guide detail pages (/guide/$slug/$guideId) keep their own routes and aren't
// shadowed. ssr:false is company doctrine, so the redirect runs client-side in
// beforeLoad (no SSR 301); `throw: true` makes redirect() throw the navigation.
export const Route = createFileRoute(`/guide/`)({
  ssr: false,
  beforeLoad: () => {
    redirect({ to: `/trips/explore`, throw: true })
  },
})
